import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";

function Results(props) {
    const {store, id} = props;
    const {interactionsStore, resultStore, persistStore} = store;
    const resultSet = resultStore.interactiveElements.get(id);
    const persistSet = persistStore.interactiveElements.get(id);

    const displayResult = (question, option) => {
        if (interactionsStore.mobileMode) {
            const perc = option / question.total * 100;
            return Math.round(perc) + '%';
        }
        const ofMax = option / question.maximum * 100;
        return <div className="resultBar" style={{width: ofMax + '%'}}/>
    };

    const includedQuestions = [];
    const predicate = (question) => {
        if (!question.audience || question.audience.length === 0) return true;//no 'audience' means all will see
        return question.audience.indexOf(persistStore.profile) > -1;
    };

    resultSet.questions.forEach((question, key) => {
        if (predicate(question)) {
            includedQuestions.push(question);
        }
    });

    const renderTable = (question) => {
        const pQuestion = persistSet.questions[question.idx];
        return <Fragment>
            <p>{pQuestion.question}</p>
            <table>
                <tbody>
                {question.options.map((option, y) => <tr key={"option" + y} className="option">
                    <td className={"text " + (pQuestion.options[y].selected ? 'active' : '')}>
                        {pQuestion.options[y].text}
                    </td>
                    <td className="check">
                        {(pQuestion.options[y].selected ? <span>&#10003;</span> : '-')}
                    </td>
                    <td className="bar">
                        {displayResult(question, option)}
                    </td>
                </tr>)}
                <tr>
                    <td className="space">

                    </td>
                    <td className="you">
                        You
                    </td>
                    <td className="others">
                        Others
                    </td>
                </tr>
                </tbody>
            </table>
        </Fragment>
    };

    return (
        <div className="Results">
            <h3>You have had your say, thank you!</h3>
            <i>See what others are saying...</i>
            <div className="question">
                {includedQuestions.map((question, i) => <div key={"question" + i}>
                    {renderTable(question)}
                </div>)}
            </div>
        </div>

    );
}

export default observer(Results);
